import { TextAreaInput } from "swing-components";

import type { TextAreaAnswerType } from "~onboarding/utils";

type TextAreaAnswerProps = Omit<TextAreaAnswerType, "type"> & {
  /**
   * The value of the entered text.
   */
  value?: string;
  /**
   * When entering text, pass the `value` to the parent.
   */
  onChange: (value?: string) => void;
  /**
   * Disables the editability of the answer.
   */
  isReadOnly?: boolean;
};

export function TextAreaAnswer(props: TextAreaAnswerProps) {
  const { value, onChange, isReadOnly, label, placeholder, maxCharacters } = props;

  function handleChange(newValue: string) {
    // An empty string is considered an unanswered question
    onChange(newValue === "" ? undefined : newValue);
  }

  return (
    <div>
      <TextAreaInput
        value={value}
        onChange={handleChange}
        isDisabled={isReadOnly}
        label={label}
        placeholder={placeholder}
      />
      {maxCharacters && (
        <div style={{ textAlign: "right", fontSize: "12px", color: "#666", marginTop: "4px" }}>
          {(value || "").length}/{maxCharacters}
        </div>
      )}
    </div>
  );
}
